// BloqueoSuscripcion.js — Pantalla del modo Mentor cuando la suscripción venció
// o el curso no está en el plan del alumno (403 de mentor/start.php con code
// 'suscripcion_vencida' | 'fuera_de_plan'). Fase 4 de suscripciones.
// Planes de formación (Learning): 'acceso_inactivo' (subrol Inactivo) y 'fuera_de_plan_formacion'
// (el curso no está asignado a su subrol: lo lleva a «Mis cursos obligatorios»).
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Fondo = styled.div`
  min-height: 100vh; display: grid; place-items: center; padding: 6rem 1.25rem 3rem; box-sizing: border-box;
  background: radial-gradient(80% 60% at 50% 0%, rgba(20, 182, 203, .14), transparent 60%), #0b1220;
  font-family: 'Bricolage Grotesque', 'Inter', system-ui, sans-serif;
`;
const Caja = styled.div`
  width: min(520px, 100%); padding: 2.2rem 2rem 2rem; border-radius: 22px; text-align: center; color: #c9d4e2;
  background: linear-gradient(160deg, rgba(255,255,255,.07), rgba(255,255,255,.02)); box-shadow: inset 0 0 0 1px rgba(255,255,255,.1), 0 30px 80px -30px #000;
  .ico { display: grid; place-items: center; width: 72px; height: 72px; margin: 0 auto 1.2rem; border-radius: 50%;
    background: ${p => (p.$vencida ? 'rgba(245, 158, 11, .15)' : 'rgba(99, 102, 241, .16)')}; color: ${p => (p.$vencida ? '#fbbf24' : '#a5b4fc')}; }
  .ico svg { width: 34px; height: 34px; }
  h1 { margin: 0 0 .5rem; font-size: 1.7rem; font-weight: 800; color: #fff; line-height: 1.15; }
  p { margin: 0 auto 1.4rem; max-width: 26rem; line-height: 1.55; }
  .dato { display: inline-flex; gap: .4rem; margin-bottom: 1.5rem; padding: .4rem .9rem; border-radius: 999px; background: rgba(255,255,255,.06); font-size: .88rem; }
  .dato b { color: #fff; }
  .botones { display: flex; gap: .6rem; justify-content: center; flex-wrap: wrap; }
  a { display: inline-flex; align-items: center; height: 48px; padding: 0 1.4rem; border-radius: 12px; font-weight: 700; text-decoration: none; }
  a.ppal { background: #14b6cb; color: #04232a; box-shadow: 0 12px 28px -12px #14b6cb; }
  a.sec { background: rgba(255,255,255,.08); color: #fff; }
  a:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }
`;

const fecha = (iso) => (iso ? new Date(iso).toLocaleDateString('es-CO', { timeZone: 'America/Bogota', day: 'numeric', month: 'long', year: 'numeric' }) : '');

const BloqueoSuscripcion = ({ code, suscripcion = {}, volver = '/' }) => {
  const inactivo = code === 'acceso_inactivo';
  const fueraFormacion = code === 'fuera_de_plan_formacion';
  const vencida = code === 'suscripcion_vencida' || inactivo;
  const renovar = suscripcion.url_renovar || '/contactanos?tema=pagos';
  const externo = /^https?:/.test(renovar);
  return (
    <Fondo>
      <Caja $vencida={vencida} role="alert">
        <div className="ico" aria-hidden="true">
          {vencida
            ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2.5 1.5M9 2h6" /></svg>
            : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4.5" y="10.5" width="15" height="10" rx="2.5" /><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" /></svg>}
        </div>
        <h1>{inactivo ? 'Tu acceso está inactivo' : fueraFormacion ? 'Este curso no está en tu plan de formación' : vencida ? 'Tu suscripción venció' : 'Este curso no está en tu plan'}</h1>
        <p>{inactivo
          ? 'Renueva tu suscripción o escríbenos para reactivarlo. Tu avance y tus certificados siguen guardados.'
          : fueraFormacion
            ? 'Tu institución te asignó otros cursos. Los encuentras en «Mis cursos obligatorios».'
            : vencida
              ? 'Renuévala para seguir con tus cursos. Tu avance y tus certificados siguen guardados: retomas donde quedaste.'
              : 'Tu plan incluye otros cursos. Si quieres este, cambia de plan o escríbenos.'}</p>
        {!fueraFormacion && (suscripcion.plan?.nombre || suscripcion.vence_en) && (
          <div className="dato">
            {suscripcion.plan?.nombre && <span>Plan <b>{suscripcion.plan.nombre}</b></span>}
            {vencida && suscripcion.vence_en && <span>· venció el <b>{fecha(suscripcion.vence_en)}</b></span>}
          </div>
        )}
        <div className="botones">
          {fueraFormacion ? <Link className="ppal" to="/">Ver mis cursos obligatorios</Link> : externo
            ? <a className="ppal" href={renovar} target="_blank" rel="noopener noreferrer">{vencida ? 'Renovar suscripción' : 'Cambiar de plan'}</a>
            : <Link className="ppal" to={renovar}>{vencida ? 'Renovar suscripción' : 'Cambiar de plan'}</Link>}
          <Link className="sec" to={volver}>Volver</Link>
        </div>
      </Caja>
    </Fondo>
  );
};

export default BloqueoSuscripcion;
